import styled from "styled-components";
import {VFlex} from "../Flex/VFlex";

export const FiltersWrapper = styled(VFlex)`
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-end;

    .filter-item {
        flex: 1 1 200px;
        min-width: 200px;
        max-width: 300px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    @media (max-width: 768px) {
        .filter-item {
            min-width: 48%;
        }
    }

    @media (max-width: 640px) {
        .filter-item {
            min-width: 100%;
        }
    }
`;
